document.addEventListener("DOMContentLoaded", () => {

    if (!location.pathname.includes("/collections/shop-all")) return;

    const ORDER = [
        "tops",
        "dresses",
        "skirts",
        "pants",
        "shorts",
        "beauty",
        "makeup",
        "accessories",
        "home-wear",
        "jumpsuits-two-piece-outfits"
    ];

    const grid = document.querySelector("#product-grid .collection__container");
    if (!grid) return;

    const cards = [...grid.querySelectorAll(".product-card")];

    const buckets = {};

    ORDER.forEach(x => buckets[x] = []);

    cards.forEach(card => {

        const cols = (card.dataset.collections || "")
            .toLowerCase()
            .split(",")
            .map(x => x.trim());

        const type = ORDER.find(x => cols.includes(x));

        if (type) {
            buckets[type].push(card);
        }

    });

    const result = [];

    while (true) {

        let found = false;

        ORDER.forEach(type => {

            if (buckets[type].length) {

                result.push(buckets[type].shift());

                found = true;

            }

        });

        if (!found) break;

    }

    result.forEach(card => grid.appendChild(card));

});